import api from "@/services/api";

interface CustomerType {
  id: string;
  name: string;
  email: string;
  phone: string;
  document: string;
  createdAt: string;
}

class GetAllCustomers {
  execute = async () => {
    const customersResponse = await api().get(`/customers`);
    return customersResponse.data as CustomerType[];
  };
}

export { GetAllCustomers };
